import { eGabinetPasswordValidation } from '@dreryk/egabinet-security-frontend';
import { Validate } from '@dreryk/react-common';
import { PasswordInput } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../../../translations';
import { PasswordUpdateFormBean, PasswordUpdateFormController } from '../PasswordUpdateForm.types';

import { OldPasswordField } from './OldPasswordField';

type NewPasswordFieldProps = Pick<PasswordUpdateFormController, 'register'>;

const validate: Validate<PasswordUpdateFormBean> = (data, getValue) => {
   const oldPassword = getValue(OldPasswordField.fieldName);
   if (oldPassword === data) {
      return personnelTranslationKeys.myAccount.password.passwordIsNotDifferent;
   }

   if (!eGabinetPasswordValidation(data as string)) {
      return personnelTranslationKeys.myAccount.password.passwordNotMatchingRestrictions;
   }

   return undefined;
};

export const NewPasswordField = (props: NewPasswordFieldProps): JSX.Element => {
   const controller = props.register(NewPasswordField.fieldName, { required: true, validate: validate });

   return (
      <PasswordInput
         testId={'newPassword'}
         autoComplete={'new-password'}
         label={personnelTranslationKeys.myAccount.password.newPassword}
         controller={controller}
      />
   );
};

NewPasswordField.fieldName = 'newPassword' as const;
